import { Helmet } from "react-helmet-async"
import { HotelChildAges, IHotel } from "../../../../Hotels"
import { useOutletContext } from "../../../../router-utils"

export default function HotelChildAgesPage() {
	const { hotel, revalidate } = useOutletContext<{
		hotel: IHotel
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Child Ages | Hotel</title>
			</Helmet>
			<HotelChildAges hotel={hotel} onChange={revalidate} />
		</>
	)
}
